import React from "react";
import {
  Row,
  Col,
  Button,
  Progress
} from "antd";
import cloneDeep from "lodash.clonedeep";
import {
  OnPeerCompleteToOwnerURL,
} from "./../../modules/emails/endpoints";

import "whatwg-fetch";
import MultipleChoice from "../../components/MultipleChoice";
import {
  questionsDK,
  questionsEN,
  questionsDK_TA,
  questionsEN_TA,
  questionsDK_Drivers,
  questionsEN_Drivers
} from "./questions";

const intl = {
  name: {
    en: "FULL NAME",
    dk: "FULDE NAVN"
  },
  buttonSubmit: {
    en: "SUBMIT EVALUATION",
    dk: "INDSEND EVALUERING"
  },
  buttonSubmitPeer: {
    en: "COMPLETE EVALUATION",
    dk: "GENNEMFØR EVALUERING"
  },
  terms: {
    en: "By completing the survey you agree to Terms of Use and Privacy Policy",
    dk:
      "Ved at gennemfører spørgeskemaet accepterer du vores Terms of Use og Privacy Policy"
  },
  errorMessage: {
    en: "Something went wrong, please try again",
    dk: "Noget gik galt, prøv venligst igen"
  },
  explainer1: {
    en: "extremely uncharacteristic",
    dk: "ekstremt ukarakteristisk"
  },
  explainer6: {
    en: "extremely characteristic",
    dk: "ekstremt karakteristisk"
  },
  next: {
    en: "Next question",
    dk: "Næste spørgsmål"
  }
};

class EvaluationQuestions extends React.Component {
  constructor() {
    super();
    this.state = {
      current: 0
    };
  }

  render() {

    let questionsLNG;

    let typeHeadline;

    let choices;

    switch (this.props.type) {
      case "profile":
        if (this.props.language === "en") {
          questionsLNG = questionsEN_TA
          typeHeadline = (
            <label style={{ color: "#fff" }}>
              The following is 12 lists of words (beneath) is the kind of
              words that is used when humans communicate with eachother . To
              what extent, according to your impression, do the person use the
              following words or phrases in their communication with others?
              (He/she might not use all the words, but words similiar in
              meaning).
            </label>
          )
        }

        if (this.props.language === "da") {
          questionsLNG = questionsDK_TA
          typeHeadline = (
            <label style={{ color: "#fff" }}>
              Følgende 12 lister af ord (underneden) er den slags ord som
              bruges når mennesker kommunikerer med hinanden. I hvilken
              udstrækning, efter din mening, bruger personen følgende ord
              eller vendinger i deres kommunikation med andre? (Han/hun bruger
              måske ikke alle ordene, men ord som bibringer den samme mening).
            </label>
          )
        }
        choices = [
          {
            description:
              this.props.language === "en" ? "Almost never" : "Næsten aldrig",
            value: 1,
            title: "1"
          },
          {
            description: this.props.language === "en" ? "Rarely" : "Sjældent",
            value: 2,
            title: "2"
          },
          {
            description:
              this.props.language === "en" ? "Sometimes" : "Nogle gange",
            value: 3,
            title: "3"
          },
          {
            description: this.props.language === "en" ? "Often" : "Ofte",
            value: 4,
            title: "4"
          },
          {
            description:
              this.props.language === "en" ? "Almost always" : "Næsten altid",
            value: 5,
            title: "5"
          }
        ];

        break;
      case "twentyfivesections":
        choices = [
          {
            description: this.props.language === "en" ? "Yes" : "Ja",
            value: 1
          },
          {
            description:
              this.props.language === "en" ? "To some extent" : "I nogen grad",
            value: 0.5
          },
          {
            description: this.props.language === "en" ? "No" : "Nej",
            value: 0.1
          }
        ];

        questionsLNG =
          this.props.language === "en"
            ? questionsEN_Drivers
            : questionsDK_Drivers;

        break;

      default: {
        questionsLNG = cloneDeep(
          this.props.language === "en" ? questionsEN : questionsDK
        );
        choices = [
          {
            description:
              this.props.language === "en"
                ? "extremely uncharacteristic"
                : "passer ekstremt dårligt",
            value: 1,
            title: "1"
          },
          {
            description:
              this.props.language === "en"
                ? "pretty uncharacteristic"
                : "passer temmelig dårligt",
            value: 2,
            title: "2"
          },
          {
            description:
              this.props.language === "en"
                ? "somewhat uncharacteristic"
                : "passer en sjælden gang",
            value: 3,
            title: "3"
          },
          {
            description:
              this.props.language === "en"
                ? "somewhat characteristic"
                : "passer nogen gange",
            value: 4,
            title: "4"
          },
          {
            description:
              this.props.language === "en"
                ? "pretty characteristic"
                : "passer temmelig godt",
            value: 5,
            title: "5"
          },
          {
            description:
              this.props.language === "en"
                ? "extremely characteristic"
                : "passer ekstremt godt",
            value: 6,
            title: "6"
          }
        ];

        const localQuestions =
          this.props.language === "en" ? questionsEN : questionsDK;

        Object.keys(localQuestions).forEach(x => {
          questionsLNG[x].title = this.props.owner
            ? this.props.owner.split("")[0] +
            " " +
            (localQuestions[x].titlePeer
              ? localQuestions[x].titlePeer
              : localQuestions[x].title)
            : (this.props.language === "en" ? "I" : "Jeg") +
            " " +
            (localQuestions[x].titleMe
              ? localQuestions[x].titleMe
              : localQuestions[x].title);
        });

        break;
      }
    }
    const questions = this.props.questions;

    const sendMailOnCompleteToOwner = (props, peername) => {

      fetch(OnPeerCompleteToOwnerURL, {
        method: "POST",
        mode: "no-cors",

        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: new URLSearchParams({
          name: props.owner,
          peerName: peername,
          email: props.ownerEmail,
          shareLink: `https://leadershipdynamic.net/360/survey/${props.isPeerResponse}/results?step=REPORT`
        }),
      })
        .then(function (response) {
          if (response.ok) {
            return response.json();
          }

          throw new Error("Post Failed");
        })
        .catch(function (error) {
        });
    };

    return (
      <Row className="survey_content_container">
        <Col
          md={{ span: 16, offset: 4 }}
          xs={24}
          style={{ position: "absolute", top: "-190px" }}
        >
          {typeHeadline}

          <Progress
            percent={parseInt(
              (this.state.current / Object.keys(questions).length) * 100,
              10
            )}
            strokeWidth="20px"
          />
        </Col>
        <Col md={{ span: 16, offset: 4 }} xs={24}>
          <Row gutter={16}>
            <form
              onSubmit={e => {
                e.preventDefault();

                if (this.props.isPeerResponse) {
                  this.props.completeEvaluation(this.input.value);
                  sendMailOnCompleteToOwner(this.props, this.input.value);
                }
                this.props.completeEvaluation();
              }}
            >
              {this.props.isPeerResponse && (
                <Col key="name" md={24} style={{ marginBottom: "20px" }}>
                  <input
                    id="name"
                    type="text"
                    name="name"
                    size="large"
                    ref={input => (this.input = input)}
                    placeholder={intl.name[this.props.language]}
                    // onChange={(e) => this.props.updateEvaluation({ fullName: e.target.value })}
                    style={{
                      textAlign: "center",
                      color: "#1abc9c",
                      fontSize: "16px",
                      width: "100%",
                      border: "none",
                      padding: "10px",
                      borderRadius: "5px",
                      outline: "none"
                    }}
                    required
                  />
                </Col>
              )}

              {Object.keys(questions).map((key, index) => (
                <Col
                  key={key}
                  md={24}
                  className={`${index === this.state.current &&
                    "evalution_question_current"}
                  ${this.state.current + 1 === index &&
                    "evalution_question_next_1"}
                  ${this.state.current + 2 === index &&
                    "evalution_question_next_2"}
                  evalution_question_wrapper`}
                  style={{ marginBottom: "20px" }}
                >
                  <MultipleChoice
                    key={key}
                    id={key}
                    title={questionsLNG[key].title}
                    value={questions[key].value}
                    choices={choices}
                    onChange={e => {
                      const self = this;
                      this.props.updateEvaluationQuestion(
                        key,
                        e.target.value,
                        () => {
                          self.setState({ current: self.state.current + 1 });
                        }
                      );
                    }}
                  />
                  <div
                    style={{
                      color: "#c0c0c0",
                      position: "absolute",
                      right: "20px",

                      top: "10px"
                    }}
                  >
                    {index + 1}/{Object.keys(questions).length}
                  </div>
                  <div
                    style={{
                      color: "#c0c0c0",
                      position: "absolute",
                      width: "100%",
                      bottom: "5px"
                    }}
                  />
                </Col>
              ))}
              {this.state.current < Object.keys(questions).length ? null : (
                <Col
                  md={{ span: 16, offset: 4 }}
                  xs={24}
                  style={{ marginTop: "10px" }}
                >
                  <Button
                    type="primary"
                    htmlType="submit"
                    size="large"
                    style={{ padding: "0 30px" }}
                    loading={this.props.submitting}
                  >
                    {this.props.isPeerResponse
                      ? intl.buttonSubmitPeer[this.props.language]
                      : intl.buttonSubmit[this.props.language]}
                  </Button>

                  <div>{intl.terms[this.props.language]}</div>
                  {this.props.error && (
                    <div style={{ color: "red" }}>
                      {intl.errorMessage[this.props.language]}
                    </div>
                  )}
                </Col>
              )}
            </form>
          </Row>
        </Col>
      </Row>
    );
  }
}

export default EvaluationQuestions;



// WEBPACK FOOTER //
// ./src/pages/Evaluation/EvaluationQuestions.js